import { render, staticRenderFns } from "./communityDetail.vue?vue&type=template&id=06d67e4e&scoped=true"
import script from "./communityDetail.vue?vue&type=script&lang=js"
export * from "./communityDetail.vue?vue&type=script&lang=js"
import style0 from "./communityDetail.vue?vue&type=style&index=0&id=06d67e4e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06d67e4e",
  null
  
)

export default component.exports